import { AxiosResponse } from 'axios';

const getFilename = (headers: AxiosResponse['headers']) => {
  const contentDisposition = headers['content-disposition'];
  if (!contentDisposition) return;

  const filenameStarMatch = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (filenameStarMatch) {
    try {
      return decodeURIComponent(filenameStarMatch[1]);
    } catch {
      /* noop */
    }
  }

  const filenameMatch = contentDisposition.match(/filename="?([^"';]+)"?/i);
  if (filenameMatch) {
    return filenameMatch[1];
  }

  return;
};

export default getFilename;
